module.exports = __webpack_public_path__ + "static/media/location.69f6f806.png";